import * as React from 'react';
export const useWidth = () => {
    const [width, setWidth] = React.useState(0);
    const ref = React.useRef(null);
    const getSize = () => {
        var _a;
        if (!ref.current)
            return;
        const newWidth = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
        setWidth(newWidth);
    };
    React.useEffect(() => {
        getSize();
        window.addEventListener('resize', getSize);
    }, []);
    return { ref, width, getSize };
};
//# sourceMappingURL=use-width.js.map